import { callApi } from "@/api/callApi";
import { API_ENDPOINT } from "@/api/constant";
import type {
  campus,
  campusByIdResponse,
  campusResponse,
} from "@/interface/campus.interface";

export const CampusService = {
  createCampus: async (payload: campus): Promise<campusResponse> => {
    const API = `${API_ENDPOINT.Campus}`;
    return callApi<campusResponse>(API, { method: "POST", data: payload });
  },

  getCampus: async (params?: string): Promise<campusResponse> => {
    const API = `${API_ENDPOINT?.Campus}${params ? `?${params}` : ""}`;
    return callApi<campusResponse>(API, { method: "GET" });
  },

  updateCampus: async (
    id: string,
    payload: campus,
  ): Promise<campusResponse> => {
    const API = `${API_ENDPOINT?.Campus}/${id}`;
    return callApi<campusResponse>(API, { method: "PUT", data: payload });
  },

  deleteCampus: async (id: string): Promise<campusResponse> => {
    const API = `${API_ENDPOINT?.Campus}/${id}`;
    return callApi<campusResponse>(API, { method: "DELETE" });
  },

  getCampusById: async (id: string): Promise<campusByIdResponse> => {
    const API = `${API_ENDPOINT?.Campus}/${id}`;
    return callApi<campusByIdResponse>(API, { method: "GET" });
  },
};
